import React from 'react';
import { Handle, Position } from 'reactflow';

const DataModelNode = ({ data }) => {
  return (
    <div className="group relative bg-white border-2 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-200 border-gray-300 w-[280px]">
      <Handle type="target" position={Position.Bottom} />
      <div className="bg-gray-900 text-white px-4 py-2 rounded-t-md font-semibold">
        {data.name}
      </div>
      <div className="p-4">
        <div className="space-y-2">
          {data.attributes?.map((attr, index) => (
            <div
              key={index}
              className="flex justify-between items-center px-3 py-2 bg-gray-50 border rounded-md"
            >
              <span className="text-gray-700 font-medium">{attr.name}</span>
              <span className="text-gray-900 text-xs font-mono bg-white px-2 py-1 rounded-md border border-gray-300">
                {attr.type}
              </span>
            </div>
          ))}
        </div>
      </div>
      <Handle type="source" position={Position.Top} />
    </div>
  );
};

export default DataModelNode; 